module.exports = __webpack_public_path__ + "img/djurre.8f32fd58.png";